// extracted by mini-css-extract-plugin
module.exports = {"image":"ResponsiveImage_image__u_aes"};